<template>
  <div class="container profile-page-wrap">
    <div class="row">

  		<div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12 profile-menu-bar no-pad-both">
        <div class="white-box">
          <router-link to="/profile/favorites" aria-label="Mine favoritter">
    				<div class="profile-page-menu-point grey-text col-3" :class="{'active' : activePage == 'favorites'}">
    					<span class="material-icons" aria-hidden="true">favorite_border</span>
    					<span>Favoritter</span>
    				</div>
    			</router-link>
          <router-link to="/profile/groups" aria-label="Mine samlinger">
    				<div class="profile-page-menu-point grey-text col-3" :class="{'active' : activePage == 'groups'}">
    					<span class="material-icons" aria-hidden="true">folder_open</span>
    					<span>Samlinger</span>
    				</div>
    			</router-link>
          <router-link to="/profile/addresses" aria-label="Mine adresser">
    				<div class="profile-page-menu-point grey-text col-3" :class="{'active' : activePage == 'addresses'}">
    					<span class="material-icons" aria-hidden="true">place</span>
    					<span>Adresser</span>
    				</div>
    			</router-link>
          <router-link to="/profile/settings" aria-label="Mine indstillinger">
    				<div class="profile-page-menu-point grey-text col-3" :class="{'active' : activePage == 'settings'}">
    					<span class="material-icons" aria-hidden="true">settings</span>
    					<span>Indstillinger</span>
    				</div>
    			</router-link>
        </div>
  		</div>

      <ProfileFavorites v-if="activePage == 'favorites' || activePage == ''"></ProfileFavorites>

      <ProfileGroupsPage v-if="activePage == 'groups'"></ProfileGroupsPage>

      <ProfileAddresses v-if="activePage == 'addresses'"></ProfileAddresses>

  		<ProfileSettings v-if="activePage == 'settings'"></ProfileSettings>

    </div>
  </div>
</template>

<script>
import Profile from '@/assets/profile/Profile.js'
import ProfileFavorites from '@/components/profile/ProfileFavorites.vue'
import ProfileGroupsPage from '@/components/profile/ProfileGroupsPage.vue'
import ProfileAddresses from '@/components/profile/ProfileAddresses.vue'
import ProfileSettings from '@/components/profile/ProfileSettings.vue'

export default {
  props: {
    activePage: {
      default: 'favorites',
    }
  },
  components: {
    ProfileFavorites, ProfileGroupsPage, ProfileAddresses, ProfileSettings,
  },
  created() {
    this.$HelperFunctions.scrollToTop();
    this.$HelperFunctions.setPageTitle('Profil');
  },
  mounted() {
    this.$HelperFunctions.setScreenReaderFocus();
  }
}
</script>

<style lang="scss" scoped>
  .profile-page-wrap {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .profile-menu-bar {
    text-align: center;
  }

  .profile-menu-bar a:hover {
  	text-decoration: none;
  }

  .profile-page-menu-point {
  	display: inline-block;
    height: 50px;
    margin: 20px 0px;
    padding: 0px;
  }

  .profile-page-menu-point.active {
  	color: rgb(0,112,141);
  }

  .profile-page-menu-point span {
    display: block;
  }
</style>
